import { render } from "./blackListDatabase.vue?vue&type=template&id=07b06d04&scoped=true"
import script from "./blackListDatabase.vue?vue&type=script&lang=js"
export * from "./blackListDatabase.vue?vue&type=script&lang=js"

import "./blackListDatabase.vue?vue&type=style&index=0&id=07b06d04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07b06d04"

export default script